<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container>
      <!-- 主表单区域 -->
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="8" >
            <a-form-item :label="$t('label.applicationType')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['applyType',{'initialValue':'30'}]" :trigger-change="true" dictCode="sqlx" placeholder="请选择申请类型"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.company')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                :disabled="true"
                type="list"
                v-decorator="['companyCode']"
                :triggerChange="true"
                dictCode="sys_depart,depart_name,org_code,org_category='1' and del_flag='0'"
                placeholder="请选择所属公司"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.farms')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                :disabled="true"
                type="list"
                v-decorator="['farmCode']"
                :triggerChange="true"
                dictCode="sys_depart,depart_name,org_code"
                :placeholder="$t('label.pleaseSelectFarms')"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.feedingLot')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                :disabled="true"
                :placeholder="$t('label.pleaseSelectTheFeedingLot')"
                ref="findBreedBatchs"
                v-decorator="['breedBatchCode',validatorRules.breedBatchCode]"
              >
                <a-select-option :value="undefined">{{$t('tip.pleaseSelect')}}</a-select-option>
                <a-select-option v-for="(item, key) in breedBatchs" :key="key" :value="item.code">
                  <span style="display: inline-block;width: 100%" :title="item.code">
                    {{ item.code }}
                  </span>
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.contractID')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input :disabled="true" v-decorator="['contractCode']" placeholder="合同号"></a-input>
            </a-form-item>
          </a-col>
<!--          <a-col :span="8" >-->
<!--            <a-form-item label="版本号" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--              <a-input disabled v-decorator="['applyVersion']" placeholder="版本号"></a-input>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
          <a-col :span="8" >
            <a-form-item label="金额合计" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number
                :disabled="true"
                v-decorator="['totalAmount']"
                ref="totalAmount"
                placeholder="请输入金额合计"
                style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="2" >
          </a-col>
<!--          <a-col :span="8" >-->
<!--              <a-button @click="handleTableSelect" type="primary" icon="check" >提取该批次结算物资领用明细</a-button>-->
<!--          </a-col>-->
        </a-row>
      </a-form>
    </j-form-container>
      <!-- 子表单区域 -->
    <a-tabs v-model="activeKey" @change="handleChangeTabs">
      <a-tab-pane tab="结算物资领用确认详情" :key="refKeys[0]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[0]"
          :loading="efsStlSettleApplyDetailTable.loading"
          :columns="efsStlSettleApplyDetailTable.columns"
          :dataSource="efsStlSettleApplyDetailTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="false"
          :actionButton="false"
          @valueChange="handleValueChange"
        />
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>

<script>

  import pick from 'lodash.pick'
  import { getAction } from '@/api/manage'
  import { FormTypes,getRefPromise } from '@/utils/JEditableTableUtil'
  import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import {
    getPlantAndCompanyCode,
    getConfirmByBatchCode,
    getBatchInfoByFarm} from '@/api/api'
  import JDate from '@/components/jeecg/JDate'
  import moment from "moment"

  export default {
    name: 'EfsStlSettleApplyForm',
    mixins: [JEditableTableMixin],
    components: {
      JFormContainer,
      JDictSelectTag,
    },
    data() {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        // 新增时子表默认添加几行空数据
        addDefaultRowNum: 0,
        farmDicCode: "",
        validatorRules: {
          breedBatchCode: {
            rules: [
              { required: true, message: this.$t('label.pleaseSelectTheFeedingLot')},
            ]
          },
        },
        refKeys: ['efsStlSettleApplyDetail', ],
        tableKeys:['efsStlSettleApplyDetail', ],
        activeKey: 'efsStlSettleApplyDetail',
        // efs_stl_settle_apply_detail
        efsStlSettleApplyDetailTable: {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: '物料类别编码',
              key: 'buffer1',
              type: FormTypes.input,
              width:"140px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              disabled: true,
              defaultValue: '',
            },
            {
              title: '物料类别名称',
              key: 'buffer2',
              type: FormTypes.input,
              width:"140px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              disabled: true,
              defaultValue: '',
            },
            {
              title: this.$t('tableHeader.materialCode'),
              key: 'mmCode',
              type: FormTypes.input,
              width:"140px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              disabled: true,
              defaultValue: '',
            },
            {
              title: this.$t('tableHeader.materialName'),
              key: 'buffer3',
              type: FormTypes.input,
              width:"140px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              disabled: true,
              defaultValue: '',
            },

            // {
            //   title: '养殖批次',
            //   key: 'breedBatchCode',
            //   type: FormTypes.input,
            //   width:"140px",
            //   placeholder: this.$t('tip.pleaseInput') +'${title}',
            //   disabled: true,
            //   defaultValue: '',
            // },
            {
              title: this.$t('tableHeader.quantity'),
              key: 'pricingQty',
              type: FormTypes.inputNumber,
              width:"80px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '1',
              disabled: true,
            },
            {
              title: this.$t('tableHeader.unitPrice'),
              key: 'unitPrice',
              type: FormTypes.inputNumber,
              width:"80px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: '合计金额',
              key: 'subtotal',
              type: FormTypes.inputNumber,
              width:"80px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
              disabled: true,
            },
            {
              title: this.$t('tableHeader.unit'),
              key: 'buffer4',
              type: FormTypes.input,
              width:"80px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              disabled: true,
              defaultValue: '',
            },
            {
              title: '时间',
              key: 'applyTime',
              width: '20%',
              type: FormTypes.date,
              placeholder: this.$t('tip.pleaseSelect') + '${title}',
              disabled: true,
              defaultValue: ''
            }
            // {
            //   title: '备注',
            //   key: 'notes',
            //   type: FormTypes.input,
            //   width:"200px",
            //   placeholder: '请输入${title}',
            //   defaultValue: '无',
            // },
          ]
        },
        url: {
          add: "/settlePickingList/efsStlSettleApply/add",
          edit: "/settlePickingList/efsStlSettleApply/edit",
          queryById: "/settlePickingList/efsStlSettleApply/queryById",
          efsStlSettleApplyDetail: {
            list: '/settlePickingList/efsStlSettleApply/queryEfsStlSettleApplyDetailByMainId'
          },
          queryByBatchCode: '/batchManage/efsMdBreedBatch/queryByBatchCodeAndValue',
        },
        breedBatchs: [],
        totalAmount:"",
        buttonShow: false,  //按钮是否显示
        initCompanyCode: null,
      }
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：false流程表单 true普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      setCompanyCode(){
        getPlantAndCompanyCode().then((res) => {
          if (res.success) {
            this.initCompanyCode = res.result.companyCode;
            console.log(this.initCompanyCode)
            // this.initFarmCodes=res.result.farmCode;
            this.changeCompanyCode(res.result.companyCode)
          }
        });
      },

      addBefore(){
        this.form.resetFields()
        this.efsStlSettleApplyDetailTable.dataSource=[];
        this.totalAmount="";
      },
      getAllTable() {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },
      /** 调用完edit()方法之后会自动调用此方法 */
      editAfter() {
        this.totalAmount="";
        let fieldval = pick(this.model,'companyCode','farmCode','breedBatchCode','contractCode','applyType','applyVersion','totalAmount','approvalStatus','lastApprover','lastApproveTime')
        this.totalAmount = this.model.totalAmount;
        this.$nextTick(() => {
          this.form.setFieldsValue(fieldval)
        })
        //编辑页面隐藏按钮
        if(this.model.id){
          this.buttonShow = false;
        }else{
          this.buttonShow = true;
        }
        // 加载子表数据
        if (this.model.id) {
          let params = { id: this.model.id }
          this.requestSubTableData(this.url.efsStlSettleApplyDetail.list, params, this.efsStlSettleApplyDetailTable)
        }
      },
      // getSubTableSubData(dataSource) {
      //   // 拿到下边表数据渲染上边form
      //   let newDataSource = dataSource
      //   newDataSource.map(item => {
      //     item.buffer3 = item.buffer3_dictText
      //   })
      //   this.efsStlSettleApplyDetailTable.dataSource = newDataSource
      // },
      /** 整理成formData */
      classifyIntoFormData(allValues) {
        let main = Object.assign(this.model, allValues.formValue)
        main.totalAmount = this.totalAmount;
        return {
          ...main, // 展开
          efsStlSettleApplyDetailList: allValues.tablesValue[0].values,
        }
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          })
        }
      },
      validateError(msg){
        this.$message.error(msg)
      },
     popupCallback(row){
       this.form.setFieldsValue(pick(
         row,
         'companyCode',
         'farmCode',
         'breedBatchCode',
         'contractCode',
         'applyType',
         'applyVersion',
         'totalAmount',
         'approvalStatus',
         'lastApprover',
         'lastApproveTime')
       )
     },
      changeCompanyCode(event) {
        this.farmDicCode = "sys_depart,depart_name,org_code,org_category = '5' and org_code like '"+event+"*' and del_flag = '0'";
        if (!this.model.id) {
          this.model.farmCode = ''
          this.model.breedBatchCode = ''
          this.form.setFieldsValue(
            pick(
              this.model,
              'farmCode',
              'breedBatchCode',
            )
          )
          this.breedBatchs = []
          this.efsStlSettleApplyDetailTable.dataSource = [];
        }
      },
      changeFarmCode(event) {
        if (!this.model.id) {
          this.model.breedBatchCode = ''
          this.form.setFieldsValue(
            pick(
              this.model,
              'breedBatchCode',
            )
          )
          this.efsStlSettleApplyDetailTable.dataSource = [];
        }
        let _request = {
          farmCode: event
        }
        getBatchInfoByFarm(_request).then(res => {
          if (res.success) {
            this.breedBatchs = res.result || []
            if (this.model.id) {
              this.breedBatchs.map(item => {
                if (item.code == this.model.breedBatchCode) {
                  this.breedBatchCode = item.breedBatchCode
                }
              })
            }
          }
        })
      },

      handleTableSelect() {
         // let value = this.$refs.findBreedBatchs.value;
         // alert(JSON.stringify(value));
        let _request = {
          breedBatchCode:  this.$refs.findBreedBatchs.value,
          type:1
        }
        getAction(this.url.queryByBatchCode, { code: this.$refs.findBreedBatchs.value }).then(res => {
            if (res.success) {
              this.form.resetFields()
              this.form.setFieldsValue({
                contractCode: res.result.conCode,
                breedBatchCode: res.result.code,
                farmCode: res.result.farmCode,
                companyCode: res.result.companyCode,
                totalAmount: res.result.countSubtotal
              })
            } else {
              this.$message.warning('请先选择批次!')
            }
          })
        getConfirmByBatchCode(_request).then(res => {
          if (res.success) {
            for (let i = 0; i < res.result.length; i++) {
              let mm = res.result[i]
              mm.breedBatchCode=mm.breedBatchCode;
              mm.buffer1=mm.mmCategory;
              mm.buffer2=mm.mmCategoryName;
              mm.mmCode = mm.mmCode;
              mm.buffer3 = mm.mmName;
              mm.buffer4=mm.unit;
              mm.unitPrice=mm.price;
              mm.pricingQty=mm.qty;
              mm.subtotal=parseFloat(mm.unitPrice * mm.pricingQty).toFixed(2);
              mm.notes="无"
            }
            this.efsStlSettleApplyDetailTable.dataSource = res.result;
          } else {
            this.efsStlSettleApplyDetailTable.dataSource = [];
          }
        })
      },
      handleBreedBatchCodeChange(value) {
        getAction(this.url.queryByBatchCode, { code: value }).then(res => {
          if (res.success) {
            this.form.setFieldsValue({
              contractCode : res.result.conCode
            })
          } else {
            this.$message.warning(res.message)
          }
        })
      },

      handleValueChange(event) {
        const { type, row, column, value, target } = event
        if(column.key === 'unitPrice' || column.key === 'pricingQty'){
          let result = parseFloat(row.unitPrice * row.pricingQty).toFixed(2);
          this.$refs.efsStlSettleApplyDetail.setValues([
            {
              rowKey: row.id, // 行的id
              values: { // 在这里 values 中的 name 是你 columns 中配置的 key
                'subtotal': result
              }
            }
          ])
          this.$refs.efsStlSettleApplyDetail.$forceUpdate();
          let main =this.$refs.efsStlSettleApplyDetail.getValuesSync().values;
          //计算总金额
          let sumAmount = 0;
          main.forEach((item) => {
            sumAmount += Number(item.subtotal);
            this.form.setFieldsValue({
              totalAmount: sumAmount,
            })
          });
        }
      },

    }
  }
</script>

<style scoped>
</style>